module.exports = function () {
  return "\n    <div class=\"debaters-overlay\" id=\"debaters-overlay\">\n    </div>\n  ";
};